import * as API from '@/endpoints'
import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    addons: null,
    isFetching: false
  },
  mutations: {
    setAddonData (state, v) {
        state.addons = v;
    },
    setAddonLoader (state, v) {
        state.isFetching = v;
    }
  },
  getters: {
    myAddOns: state => {
        return state.addons
    },
    isLoadingAddOns: state => {
        return state.isFetching
    }
  },
  actions: {
    getUserAddOns ({commit}, payload) {
      return new Promise((resolve, reject) => {
        commit('setAddonLoader', true)
        Axios.get(`${API.endpoints.base}prescribed/addons?user_story_type=${payload}`).then(
          res => {
            commit('setAddonData', res.data)
            commit('setAddonLoader', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setAddonLoader', false)
            reject(error)
          }
        )
      })
    }
  }
}
